import _ from 'lodash';
import { REGEXP } from '@/constants/regexp';
import { SHORTCUTSCONFIG } from '@/constants/reportField.js';
import { getTagList } from '@/pages/agency/manage/work-wechat-customer/services';
import { getSaleOrganizationTree, getSaleEmployeeList } from '@/pages/agency/manage/operation-log/api';
import { getIndustryList, getAreaCodeList, getPromotedObject, getSourceType, getSourceTypeTag } from '@/api/operator/cgi/smb/sale';
import { enumMessages, getMessage } from '@/utils/MessageUtils';
import { getIndustry } from '@/pages/agency/utils/industry';
import { getAreaInfo } from '@/pages/agency/utils/area';
import { PotentialStatus } from '@/model/sale';
import { materialTypeConfig } from '@/pages/agency/manage/material/config';
import { customerStatusTextMap } from '@/pages/agency/manage/work-wechat-customer/config';
const promotedObjectTextMap = {
  AD_PLATFORM_TYPE_GDT: '广点通',
  AD_PLATFORM_TYPE_MP: '微信',
  AD_PLATFORM_TYPE_NEIGHBORHOOD: '附近推',
};

const fetchSaleData = (params: any) => Promise.all([
  getSaleOrganizationTree(),
  getSaleEmployeeList({
    data: {
      field: 'USER_NAME',
    },
  }),
]);

const convertSaleData = (res: any) => {
  const [organizationTree = {}, { list: employeeList = [] } = {}] = res;
  const getEmployeeNode = (employee: any) => {
    const user = _.find(employeeList, (v) => v.employeeId === employee.userId) || {};
    return {
      value: employee.userId,
      desc: user.operationUserName || employee.name || employee.qqNumber || employee.userId,
    };
  };

  const getTeamNode: any = (team: any) => {
    return {
      value: team.name,
      desc: team.name,
      not_allow_selected: true,
      options: _.concat(
        _.map(team.children, (t) => getTeamNode(t)),
        _.compact(_.map(team.employees, (e) => getEmployeeNode(e))),
      ),
    };
  };

  return _.concat(
    _.map(organizationTree.teams || [], (t) => getTeamNode(t)),
    _.compact(_.map(organizationTree.freeEmployees || [], (e) => getEmployeeNode(e))),
  );
};

export default {
  createdTime: {
    name: 'createdTime',
    title: '添加日期',
    type: 'date-picker',
    config: {
      useNewUI: true,
      type: 'range',
      useShortcut: true,
      shortcuts: SHORTCUTSCONFIG,
      horizontalPosition: 'right',
      placeholder: '请选择添加日期',
    },
    nameMap: {
      start_time: 'addTimeBegin',
      end_time: 'addTimeEnd',
    },
  },
  tagIds: {
    name: 'tagIds',
    title: '企业标签',
    type: 'select-tree',
    config: {
      multiple: true,
      search: false,
      showParentNodeLabel: false,
      isAutoCheckedParent: false,
      valueType: 'child',
      selectTarget: 'child',
      valueAreaType: 'labels',
      placeholder: '请选择企业标签',
      fetchData: () => getTagList(),
    },
  },
  addEmployeeId: {
    name: 'addEmployeeId',
    title: '添加人',
    type: 'select-tree',
    config: {
      placeholder: '请输入添加人',
      data: [],
      fetchData: fetchSaleData,
      convertData: convertSaleData,
    },
  },
  saleEmployeeId: {
    name: 'saleEmployeeId',
    title: '跟进销售',
    type: 'select-tree',
    config: {
      placeholder: '请输入跟进销售',
      data: [],
      fetchData: fetchSaleData,
      convertData: convertSaleData,
    },
  },
  hasRelatedLead: {
    name: 'hasRelatedLead',
    title: '是否关联线索',
    type: 'select',
    config: {
      data: [{ value: 1, label: '已关联' }, { value: 0, label: '未关联' }],
    },
  },
  wechatName: {
    name: 'name',
    title: '名称',
    type: 'search',
    config: {
      placeholder: '请输入名称',
    },
  },
  wechatCustomerStatus: {
    name: 'status',
    title: '客户状态',
    type: 'select',
    config: {
      data: customerStatusTextMap,
    },
  },
  leadId: {
    name: 'leadId',
    title: '线索ID',
    type: 'search',
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
    config: {
      placeholder: '请输入线索ID',
    },
  },
  contactName: {
    name: 'contactName',
    title: '联系人',
    type: 'search',
    config: {
      placeholder: '请输入联系人',
    },
  },
  contactMobile: {
    name: 'mobile',
    title: '联系人电话',
    type: 'search',
    config: {
      placeholder: '请输入联系人电话',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  companyName: {
    name: 'companyName',
    title: '公司名称',
    type: 'search',
    config: {
      placeholder: '请输入公司名称',
    },
  },
  materialId: {
    name: 'materialId',
    title: '素材ID',
    type: 'search',
    config: {
      placeholder: '请输入素材ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  materialTitle: {
    name: 'materialTitle',
    title: '素材名称',
    type: 'search',
    config: {
      placeholder: '请输入素材名称',
    },
  },
  materialType: {
    name: 'materialType',
    title: '分类',
    type: 'select',
    config: {
      data: materialTypeConfig,
    },
  },
  systemSourceTypes: {
    name: 'systemSourceTypes',
    title: '线索来源',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getSourceType(),
      convertData: (data: any) => {
        return Object.keys(data || {}).map((v) => {
          const options = data[v].map((w: any) => {
            const desc = getMessage(w, 'SystemSourceType') || '未知';
            return { value: w, desc, parent_id: v };
          });
          const desc =  getMessage(v, 'LeadSourceType') || '未知';
          return { value: v, desc, options };
        });
      },
    },
  },
  sourceTypeTags: {
    name: 'sourceTypeTags',
    title: '线索标签',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getSourceTypeTag(),
      convertData: (data: any) => {
        return Object.values(data).map((x: any) => {
          return x.map((v: any) => {
            const { firstLevelLabel, secondLevelLabel } = v;
            const options = (secondLevelLabel || []).map((w: any) => {
              const { leadLabelId, leadLabel } = w;
              return { value: leadLabelId, desc: leadLabel, parent_id: firstLevelLabel.leadLabelId };
            });
            const { leadLabelId, leadLabel } = firstLevelLabel;
            return { value: leadLabelId, desc: leadLabel, options };
          });
        })
          .flat();
      },
    },
  },
  intentions: {
    name: 'intentions',
    title: '推广目标',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getPromotedObject(),
      convertData: (data: any) => {
        return Object.keys(data).map((v) => {
          const options = Object.keys(data[v]).map((w) => {
            return { value: `${v}-${w}`, desc: data[v][w], parent_id: v };
          });
          return { value: v, desc: promotedObjectTextMap[v] || '未知', options };
        });
      },
    },
  },
  stepStatuses: {
    name: 'stepStatuses',
    title: '阶段/状态',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [
        { value: 'PROGRESS_STATUS_LEAD', desc: '线索', options: enumMessages('CleaningStatus').map(({ value, message }) => ({ value, desc: message, parent_id: 'PROGRESS_STATUS_LEAD' })) || [] },
        { value: 'PROGRESS_STATUS_POTENTIAL', desc: '商机', options: enumMessages('MixedPotentialStatus').filter(({ value }) => !value.endsWith('100'))
          .map(({ value, message }) => {
            const [potentialStatus, transactionProbability] = value.split('-');
            return {
              value: potentialStatus === PotentialStatus.new ? potentialStatus : Number(transactionProbability),
              desc: message,
              parent_id: 'PROGRESS_STATUS_POTENTIAL',
            };
          }) || [] },
        { value: 'PROGRESS_STATUS_ORDER', desc: '订单', options: enumMessages('OrderStatus').map(({ value, message }) => ({ value, desc: message, parent_id: 'PROGRESS_STATUS_ORDER' })) || [] },
      ],
    },
  },
  area_code_list_sale: {
    name: 'area_code_list',
    title: '地区',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getAreaCodeList(),
      convertData: (res: any) => {
        const { items } = getAreaInfo(res || []);
        return items || [];
      },
    },
  },
  industry_id_list_sale: {
    name: 'industry_id_list',
    title: '行业',
    type: 'select-tree',
    config: {
      multiple: true,
      data: [],
      fetchData: () => getIndustryList(),
      convertData: (res: any) => {
        return getIndustry(res || []) || [];
      },
    },
  },
  groupMsgId: {
    name: 'groupMsgId',
    title: '群发ID',
    type: 'search',
    config: {
      placeholder: '请输入群发ID',
    },
    rules: [
      {
        pattern: REGEXP.number,
        message: '请输入数字类型，形如：100',
      },
    ],
  },
  groupMsgStatus: {
    name: 'groupMsgStatus',
    title: '发送状态',
    type: 'select',
    config: {
      data: [
        { value: 'GROUP_MSG_SENDING', label: '发送中' },
        { value: 'GROUP_MSG_ALREADY_SEND', label: '已发送' },
      ],
    },
  },
};
